import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
import BannerSliderMobile from 'components_v2/mobile/BannerSlider';
import s from './LoksabhaElectionExitPollWrapper.scss';
import MiniResultStatus from '../../../components/ElectionV2/common/MiniResultStatus/MiniResultStatus';
import { TOI_LIVE_DOMAIN } from '../../../constants';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2/HeaderTab';
import { loadLokSabhaExitPoll } from '../../../components/ElectionV2/loksabha_redux';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import BannerSlider from '../../desktop/BannerSlider/BannerSlider';
import DataBarsWrapper from '../../../components/ElectionV2/common/DataBarsWrapper/DataBarsWrapper';
import SortSelect from '../SortSelect';
import DataBar from '../../../components/ElectionV2/common/DataBar/DataBar';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import StateWrapper from '../../../components/ElectionV2/common/StateWrapper/StateWrapper';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

class LoksabhaElectionExitPollWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.stateResultWrapRef = React.createRef();
    const { electionData } = this.props?.sectionData?.items || {};
    try {
      if (electionData) {
        const currentData = Object.values(electionData)
          .filter(e => e.resultUrl)
          .sort((a, b) => b.year - a.year)[0];
        if (currentData) {
          this.state.currentData = currentData;
        }
      }
    } catch (error) {
      //
    }
  }

  onTabsChange = params => {
    const { exitPollObject } = params.clickedItem;
    this.setState({
      currentData: params.clickedItem,
    });
    this.props.loadAjaxResultData(exitPollObject, true);
  };

  handleSourceOnChange = e => {
    this.setState({ selectedSource: e });
    // eslint-disable-next-line no-nested-ternary
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'exitpoll_widget',
      category: this.props?.config?.name || 'Assembly Elections',
      label: e.name,
    });
  };

  renderElection() {
    const { electionData } = this.props?.sectionData?.items || {};
    const {
      isWapView,
      sortedData,
      infoMsg,
      infoMsgCommon,
      isExitPoll,
    } = this.props;

    const { exitPollSource, finalSourceData, selectedSource } =
      sortedData || {};

    const { majority = 0, activeSeats = 0, sortedAlRslt = [] } =
      finalSourceData?.[
        this.state?.selectedSource?.name || selectedSource?.name
      ]?.nation?.india || {};

    const lokSabhaStateMap = isExitPoll
      ? finalSourceData?.[
          this.state?.selectedSource?.name || selectedSource?.name
        ]?.states || {}
      : sortedData?.states || {};

    const lokSabhaStates = Object.values(lokSabhaStateMap) || [];

    const powerStates =
      (lokSabhaStates &&
        Array.isArray(lokSabhaStates) &&
        lokSabhaStates.filter(str => str.powerState === '1')) ||
      [];

    const unPowerStates =
      (lokSabhaStates &&
        Array.isArray(lokSabhaStates) &&
        lokSabhaStates.filter(str => str.powerState !== '1')) ||
      [];

    return (
      <>
        <div className={s.switchTabsWrap} ref={this.stateResultWrapRef}>
          <Listingheader headingname="Exit Polls" />
          <div className={s.tabs}>
            <span>Year :</span>{' '}
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(ed => ed.exitPollUrl)
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: ed.exitPollUrl,
                  link: ed.exitPollUrl,
                }))}
              onChangeCallback={this.onTabsChange}
            />
          </div>
        </div>
        <>
          <div className="boxStyle">
            {activeSeats > 0 &&
            majority > 0 &&
            selectedSource &&
            selectedSource?.name ? (
              <>
                {(this.state?.selectedSource || selectedSource) &&
                  exitPollSource &&
                  Array.isArray(exitPollSource) &&
                  exitPollSource.length > 0 && (
                    <div className={s.sortSearchWrap}>
                      <AdCaller data={{ name: 'exit_first' }} immediateLoad />
                      <SortSelect
                        options={exitPollSource}
                        onSelect={this.handleSourceOnChange}
                        selectedOption={
                          this.state?.selectedSource || selectedSource
                        }
                        placeHolder="Source"
                        typeTwoStyle
                      />
                    </div>
                  )}
                <ErrorBoundary>
                  {sortedAlRslt &&
                  Array.isArray(sortedAlRslt) &&
                  sortedAlRslt.length > 0 ? (
                    <DataBarsWrapper
                      totalSeats={activeSeats}
                      majority={majority}
                      exitPoll
                      noMinHeight
                      infoMsg={infoMsg}
                    >
                      {sortedAlRslt &&
                        Array.isArray(sortedAlRslt) &&
                        sortedAlRslt.length > 0 &&
                        sortedAlRslt.map(party => (
                          <DataBar
                            color={party.cc || party.color}
                            name={party.an}
                            ws={party.ls}
                            wsc={party.wsc}
                            ttl_seat={activeSeats}
                          />
                        ))}
                    </DataBarsWrapper>
                  ) : (
                    <div className="noDataFound">
                      National level data awaited for {selectedSource?.name}
                    </div>
                  )}
                </ErrorBoundary>
              </>
            ) : (
              <div className="noDataFound">National level data awaited</div>
            )}
          </div>
          {infoMsgCommon && (
            <div className={s.infoMsgCommon}>{infoMsgCommon}</div>
          )}
        </>
        {lokSabhaStates &&
          Array.isArray(lokSabhaStates) &&
          lokSabhaStates.length > 0 &&
          powerStates &&
          Array.isArray(powerStates) &&
          powerStates.length > 0 && (
            <>
              <Listingheader headingname="Power States" />
              <StateWrapper>
                <>
                  {powerStates.map(ps => (
                    <MiniResultStatus
                      parties={ps?.sortedAlRslt}
                      isExitPoll
                      activeSeats={ps?.activeSeats}
                      infoMsg={ps?.infoMsg}
                      name={ps?.sn}
                      path={`${TOI_LIVE_DOMAIN}/elections/${
                        ps?.sseo
                      }-lok-sabha-election`}
                    />
                  ))}
                </>
              </StateWrapper>
            </>
          )}
        {this.props?.sectionData?.items?.banner && (
          <>
            <AdCaller data={{ jname: 'rsltdayewbottom' }} immediateLoad />
            <div className={s.bannerSliderWrap}>
              {!isWapView ? (
                <BannerSlider
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              ) : (
                <BannerSliderMobile
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              )}
            </div>
          </>
        )}
        {lokSabhaStates &&
          Array.isArray(lokSabhaStates) &&
          lokSabhaStates.length > 0 &&
          unPowerStates &&
          Array.isArray(unPowerStates) &&
          unPowerStates.length > 0 && (
            <>
              <Listingheader headingname="Other States" />
              <StateWrapper>
                {unPowerStates.map(ups => (
                  <MiniResultStatus
                    parties={ups?.sortedAlRslt}
                    isExitPoll
                    activeSeats={ups?.activeSeats}
                    infoMsg={ups?.infoMsg}
                    name={ups?.sn}
                    path={`${TOI_LIVE_DOMAIN}/elections/${
                      ups.sseo
                    }-lok-sabha-election`}
                  />
                ))}
              </StateWrapper>
            </>
          )}
      </>
    );
  }

  render() {
    return (
      <div className={s.exitPollShowPageWidgetWrapper} ref={this.ref}>
        {this.props.dataLoading && <LoaderSpinner />}
        {this.state?.currentData &&
          this.state?.currentData?.note && (
            <p className={s.noteText}>{this.state?.currentData?.note}</p>
          )}
        <div className="mt">{this.renderElection()}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.lokSabhaElection?.refreshinterval,
  electionData: state?.lokSabhaElection?.electionData,
  starCandidateData: state?.lokSabhaElection?.starCandidateData,
  isExitPoll: state?.lokSabhaElection?.isExitPoll,
  displaytext: state?.lokSabhaElection?.displaytext,
  keywords: state?.lokSabhaElection?.keywords,
  breakingnews: state?.lokSabhaElection?.breakingnews,
  states: state?.lokSabhaElection?.states,
  liveblog: state?.lokSabhaElection?.liveblog,
  datasource: state?.lokSabhaElection?.datasource,
  hideexitheading: state?.lokSabhaElection?.hideexitheading,
  path: state?.lokSabhaElection?.path,
  exitPollStateData: state?.lokSabhaElection?.exitPollStateData,
  sortedData: state?.lokSabhaElection?.sortedData,
  infoMsg: state?.lokSabhaElection?.infoMsg,
  prMasterMap: state?.lokSabhaElection?.prMasterMap,
  alMasterMap: state?.lokSabhaElection?.alMasterMap,
  dataLoading: state?.lokSabhaElection?.dataLoading,
  infoMsgCommon: state?.lokSabhaElection?.infoMsgCommon,
});

const mapDispatchToProps = dispatch => ({
  loadAjaxResultData: (resultObject, loader = false) => {
    dispatch(loadLokSabhaExitPoll(resultObject, loader));
  },
});

LoksabhaElectionExitPollWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
};
LoksabhaElectionExitPollWrapper.defaultProps = {
  isWapView: false,
  data: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoksabhaElectionExitPollWrapper,
);
